$("#fakeLoader").fakeLoader({
    timeToHide: 1200, //Time in milliseconds for fakeLoader disappear
    zIndex: "9999",//Default zIndex
    spinner: "spinner1",//Options: 'spinner1', 'spinner2', 'spinner3', 'spinner4', 'spinner5', 'spinner6', 'spinner7'
    bgColor: "#252525" //Hex, RGB or RGBA colors
});
$(function () {
    EcomCheckout.init();
});
$(function () {
    Pricing.init();
});
toastr.options = {
    "closeButton": true,
    "debug": false,
    "newestOnTop": false,
    "progressBar": true,
    "positionClass": "toast-top-right",
    "preventDuplicates": false,
    "onclick": null,
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "5000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
}
jQuery(document).ready(function ($) {

    $('.opacity .btn').each(function (index, el) {
        $(this).addClass('disabled').addClass('btn-primary').removeClass('btn-danger').html('Não disponível');
    });

    $('#change-password').hide();
    $('#password-toggle').click(function () {
        $('#change-password').slideToggle();
        $('#change-user').slideUp();
    });

    $('#change-user').hide();
    $('#user-toggle').click(function () {
        $('#change-user').slideToggle();
        $('#change-password').slideUp();
    });


    $('[data-toggle="tooltip"]').tooltip();
    var msg = $('#msg').html();
    if (msg != undefined) {
        toastr.error(msg);
    }
    function toogleFaturamento() {
        var faturamento = $('input[name=faturamento]:checked').val();
        $('#pf, #pj').hide();
        $('#' + faturamento).show();
    }

    toogleFaturamento();

    $('input[name=faturamento]').change(function () {
        toogleFaturamento();
    });

    $('.cnpj').keyup(function () {
        var cnpj = $(".cnpj").val();
        console.log(cnpj);
        $.ajax({
                url: 'api/cnpj/',
                type: 'POST',
                data: {cnpj: cnpj},
                dataType: 'json',
            })
            .done(function (data) {
                console.log("success");
                $('.razao').val(data.nome);
                $('.cep').val(data.cep);
                $('.logradouro').val(data.logradouro);
                $('.numero').val(data.numero);
                $('.bairro').val(data.bairro);
                $('.municipio').val(data.municipio);
                $('.uf').val(data.uf);
                $('.telefone').val(data.telefone);

            })
            .fail(function () {
                console.log("error");
                $('.razao').val('');
                $('.cep').val('');
                $('.logradouro').val('');
                $('.numero').val('');
                $('.bairro').val('');
                $('.municipio').val('');
                $('.uf').val('');
                $('.telefone').val('');
            })
            .always(function () {
                console.log("complete");
            });
    });

    $('#cep').keyup(function () {
        var cep = $("#cep").val();
        console.log(cep.length);
        $.ajax({
                url: 'api/cep/',
                type: 'POST',
                data: {cep: cep},
                dataType: 'json',
            })
            .done(function (data) {
                console.log("success");
                $('#neighborhood').val(data.bairro);
                $('#address').val(data.logradouro);
                $('#state').val(data.uf);
                $('#city').val(data.localidade);
            })
            .fail(function () {
                console.log("error");
                $('#neighborhood').val('');
                $('#address').val('');
                $('#state').val('');
                $('#city').val('');
            })
            .always(function () {
                console.log("complete");
            });

    });

    $("#cpf").mask("999.999.999-99");
    $("#phone").mask("(99) 9999-9999");

    $('#cellphone').focusout(function () {
        var phone, element;
        element = $(this);
        element.unmask();
        phone = element.val().replace(/\D/g, '');
        if (phone.length > 10) {
            element.mask("(99) 99999-999?9");
        } else {
            element.mask("(99) 9999-9999?9");
        }
    }).trigger('focusout');

});

function toggleChevron(e) {
    $(e.target)
        .prev('.panel-heading')
        .find("i.indicator")
        .toggleClass('glyphicon-chevron-down glyphicon-chevron-up');
}
$('#accordion').on('hidden.bs.collapse', toggleChevron);
$('#accordion').on('shown.bs.collapse', toggleChevron);

$('.input-kids').hide();
$('.kids-a').click(function (e) {
    e.preventDefault();
    var id = $(this).data('id');
    $('#inputs-' + id).fadeToggle();
});
$('.bt-k').click(function (e) {
    e.preventDefault();
    $('.kids-it').removeClass('hide');
});